import { render, staticRenderFns } from "./registXy.vue?vue&type=template&id=09514132&scoped=true"
import script from "./registXy.vue?vue&type=script&lang=js"
export * from "./registXy.vue?vue&type=script&lang=js"
import style0 from "./registXy.vue?vue&type=style&index=0&id=09514132&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09514132",
  null
  
)

export default component.exports